import { render, staticRenderFns } from "./Subtypes.vue?vue&type=template&id=d4b31bce&scoped=true&"
import script from "./Subtypes.vue?vue&type=script&lang=js&"
export * from "./Subtypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b31bce",
  null
  
)

export default component.exports